<div class="op-backdrop" (click)="onBackdropClick()"></div>
<section
  class="op-panel"
  [class.op-side]="mode() === 'side'"
  [class.op-center]="mode() === 'center'"
  [class.op-sm]="size() === 'sm'"
  [class.op-md]="size() === 'md'"
  [class.op-lg]="size() === 'lg'"
  [class.op-xl]="size() === 'xl'"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="ariaLabel()"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
>
  <div class="op-header">
    <div class="op-title"><ng-content select="[overlay-title]" /></div>
    <button
      *ngIf="showCloseButton()"
      type="button"
      class="op-close"
      aria-label="Schließen"
      [disabled]="busy()"
      (click)="requestClose()"
    >
      ×
    </button>
  </div>
  <div class="op-body"><ng-content /></div>
  <div class="op-footer"><ng-content select="[overlay-footer]" /></div>
</section>
